import { useMemo } from 'react'
import { useReducedMotion } from 'motion/react'

export function useRevealAnimation() {
  const reduce = useReducedMotion()

  return useMemo(() => ({
    initial: { opacity: 0, y: reduce ? 0 : 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-80px' },
    transition: { duration: .65, ease: [.2, .8, .2, 1] as const },
  }), [reduce])
}
